export default __webpack_public_path__ + "static/media/printer2.6f65a47a.svg";